var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: {
        id: "address_details_mobile_modal",
        "no-close-on-backdrop": true,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "address_details_mobile_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-success",
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("addressDetailsMobileModal.saveBtn")) +
                      " "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("h2", [_vm._v(_vm._s(_vm.$t("addressDetailsMobileModal.title")))]),
      _c("div", { staticClass: "bb-form-group" }, [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("addressDetailsMobileModal.addressInput.label"))
          ),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.address,
              expression: "address",
            },
          ],
          staticClass: "bb-input",
          attrs: { type: "text" },
          domProps: { value: _vm.address },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.address = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "bb-form-group" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("addressDetailsMobileModal.cityInput.label"))),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.city,
              expression: "city",
            },
          ],
          staticClass: "bb-input",
          attrs: { type: "text" },
          domProps: { value: _vm.city },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.city = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "bb-form-group" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("addressDetailsMobileModal.stateInput.label"))),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.state,
              expression: "state",
            },
          ],
          staticClass: "bb-input",
          attrs: { type: "text" },
          domProps: { value: _vm.state },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.state = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "bb-form-group" }, [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("addressDetailsMobileModal.zipCodeInput.label"))
          ),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.zipCode,
              expression: "zipCode",
            },
          ],
          staticClass: "bb-input",
          attrs: { type: "text" },
          domProps: { value: _vm.zipCode },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.zipCode = $event.target.value
            },
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }